import { environment } from '@envs/environment';
import { JSEncrypt } from 'jsencrypt';

/**
 * Encripta una cadena usando una llave pública RSA.
 *
 * @param text Texto plano a encriptar.
 * @returns Texto encriptado en base64 o null si falla.
 */
export const encrypt = (text: string): string | null => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(environment.publicKeyRSA);

    const encrypted = encryptor.encrypt(text);
    return typeof encrypted === 'string' ? encrypted : null;
};
